import React from 'react'

import {
  StyleHeader,
  StyleContent,
  StyleFooter,
} from './style'
import { REPORT } from '../../../helpers'
import ReactModal from '../../ReactModal'
import { Button } from '../../Button'

const ModalError = (props) => {
  const {
    isVisible,
    language,
    onClose,
    colorTheme,
    detail,
  } = props

  return (
    <ReactModal
      isVisible={isVisible}
      width={416}
      borderRadius={16}
    >
      <StyleHeader>
        <label className='header-issue-modal'>{REPORT.ERROR[language]}</label>
      </StyleHeader>

      <StyleContent>
        <label className='detail-issue-modal'>{detail && detail[language]}</label>
      </StyleContent>

      <StyleFooter colorTheme={colorTheme}>
        <Button
          name={REPORT.DONE[language]}
          className='done-button'
          onClick={onClose}
        />
      </StyleFooter>
    </ReactModal>
  )
}

export default ModalError
